import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';
import clientAxios from '../clients/clientAxios';
import { notify } from 'react-notify-toast';
import { DISPLAY_TYPES, EXCEL_CONFIG, EXPORT_OPTIONS } from '../constants';

export const handleExportExcel = async ({
  exportOption,
  display,
  payment,
  year,
  since,
  to,
  JWT,
}) => {
  let exportParams = { display, payment };

  if (exportOption === EXPORT_OPTIONS.CURRENT) {
    const now = moment();
    exportParams.display = DISPLAY_TYPES.SPECIFIC;
    exportParams.since = now.startOf('month').format(EXCEL_CONFIG.DATE_FORMAT);
    exportParams.to = now.endOf('month').format(EXCEL_CONFIG.DATE_FORMAT);
  } else if (exportOption === EXPORT_OPTIONS.PREVIOUS) {
    const prevMonth = moment().subtract(1, 'month');
    exportParams.display = DISPLAY_TYPES.SPECIFIC;
    exportParams.since = prevMonth
      .startOf('month')
      .format(EXCEL_CONFIG.DATE_FORMAT);
    exportParams.to = prevMonth.endOf('month').format(EXCEL_CONFIG.DATE_FORMAT);
  } else if (exportOption === EXPORT_OPTIONS.FILTERS) {
    exportParams.display = display;
    if (display === DISPLAY_TYPES.SPECIFIC) {
      exportParams.since = since;
      exportParams.to = to;
    } else if (display === DISPLAY_TYPES.ANUAL) {
      exportParams.year = year;
    } else if (display === DISPLAY_TYPES.HISTORIC) {
      exportParams.display = DISPLAY_TYPES.SPECIFIC;
      exportParams.since = '2020-01-01';
      exportParams.to = moment().endOf('year').format(EXCEL_CONFIG.DATE_FORMAT);
    }
  }
  try {
    const { data } = await clientAxios.post('/bills/export', exportParams);
    if (!data?.data?.length) {
      notify.show('No hay datos para exportar', 'warning');
      return;
    }
    const total = data.data.reduce((acc, item) => acc + (item.Importe || 0), 0);
    const dataWithTotal = [
      ...data.data,
      { Fecha: '', Alumno: 'TOTAL', Importe: total, 'Medio de pago': '' },
    ];
    const worksheet = XLSX.utils.json_to_sheet(dataWithTotal);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, EXCEL_CONFIG.SHEET_NAME);
    worksheet['!cols'] = Object.keys(data.data[0]).map(() => ({
      wch: EXCEL_CONFIG.COLUMN_WIDTH,
    }));
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const fileName = `${EXCEL_CONFIG.FILE_PREFIX
      }_${exportOption}_${moment().format(
        EXCEL_CONFIG.FILE_TIMESTAMP_FORMAT
      )}.xlsx`;
    saveAs(blob, fileName);
  } catch (err) {
    notify.show('No se pudieron obtener los datos para exportar', 'error');
  }
};
